/* eslint-disable @next/next/no-img-element */
import React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';

const ScaledImage = styled('div')`
  overflow: hidden;
  object-fit: cover;
  width: 100%;
  height: 100%;
`;

const AdvantagesGridItem = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: '1rem',
  backgroundColor: theme.palette.grey[50],
}));

export const JobAdvantages = (): JSX.Element => {
  return (
    <Container>
      <Grid container spacing={0} style={{ marginBottom: '2rem' }}>
        <Grid item xs={12} md={6}>
          <ScaledImage>
            <img
              style={{ width: '100%', height: '100%' }}
              src="/assets/images/jobs/jobs-tech-team.webp"
              alt="Tech team on rooftop terrace having fun"
            />
          </ScaledImage>
        </Grid>

        <AdvantagesGridItem item xs={12} md={6}>
          <Typography variant="h3" component="h3">
            ~ 600 Mitarbeitende
            <br />
            50+ Nationen
          </Typography>
          <Typography variant="body1" component="p">
            smava beschäftigt rund 600 Mitarbeitende aus mehr als 50 Nationen.
          </Typography>
        </AdvantagesGridItem>

        <AdvantagesGridItem item xs={12} md={6}>
          <Typography variant="h3" component="h3">
            Ein Arbeitgeber, der sich sehen lassen kann
          </Typography>
          <Typography variant="body1" component="p">
            Bei smava stehen die Mitarbeitenden stets im Fokus, daher bieten wir
            als Arbeitgeber zahlreiche Benefits. Dich erwarten unter anderem 30
            Urlaubstage, 10 Kind-Krank-Tage zusätzlich zum gesetzlichen Anspruch
            sowie interne Karriereprogramme und Weiterbildungsmöglichkeiten.
            Darüber hinaus unterstützen wir dich mit Zuschüssen für deine
            Betriebliche Altersvorsorge und dein ÖPNV-Ticket. Mehr Infos
            diesbezüglich stellt dir gern unser People & Talent Team auf Anfrage
            zur Verfügung.
          </Typography>
        </AdvantagesGridItem>

        <Grid item xs={12} md={6}>
          <ScaledImage>
            <img
              style={{ width: '100%', height: '100%' }}
              src="/assets/images/jobs/jobs-benefits-2.webp"
              alt="Person explaining with hand gestures"
            />
          </ScaledImage>
        </Grid>

        <Grid item xs={12} md={6}>
          <ScaledImage>
            <img
              style={{ width: '100%', height: '100%' }}
              src="/assets/images/jobs/jobs-benefits-1.webp"
              alt="Diverse group with smava shirts"
            />
          </ScaledImage>
        </Grid>

        <AdvantagesGridItem item xs={12} md={6}>
          <Typography variant="h3" component="h3">
            Diversity & Inclusion
          </Typography>
          <Typography variant="body1" component="p">
            Wir setzen uns für ein diverses und inklusives Umfeld ein. Gemeinsam
            als ein Team mit unseren verschiedenen Fähigkeiten, Ideen und
            Erfahrungen arbeiten wir aktiv daran, Vielfalt im Unternehmen zu
            repräsentieren
          </Typography>
        </AdvantagesGridItem>
      </Grid>
    </Container>
  );
};
